import { Controller } from '@hotwired/stimulus'

// Reveals text hidden by a line-clamp. The toggle only appears when the text
// actually overflows its clamped box, so short bodies keep a clean card.
export default class extends Controller {
  static targets = ['text', 'toggle']
  static values = { clampClass: { type: String, default: 'line-clamp-3' } }

  connect() {
    requestAnimationFrame(() => {
      if (this.textTarget.scrollHeight > this.textTarget.clientHeight + 1) {
        this.toggleTarget.classList.remove('hidden')
      }
    })
  }

  toggle() {
    const clamped = this.textTarget.classList.toggle(this.clampClassValue)
    this.toggleTarget.textContent = clamped ? 'Ver texto completo' : 'Ver menos'
  }
}
